import React, {PropsWithChildren} from 'react';
import {MainFooter, PageWrapperLayout} from 'presentation/components';
import {FavoriteDoctorsLayoutProps} from './types';

const FavoriteDoctorsLayout = ({
	title,
	children,
}: PropsWithChildren<FavoriteDoctorsLayoutProps>) => (
	<PageWrapperLayout title={title}>
		{children}
		<MainFooter />
	</PageWrapperLayout>
);

export {FavoriteDoctorsLayout};
